import { makeStyles, Theme } from '@material-ui/core/styles'
import { HEADER_H, VENDOR_BAR_H } from './constants'
import { typographyStyle } from '../../theme/typographyStyle'
/**
 * Styles for TemplateScheduleGantt component
 */
export const useTemplateScheduleGanttStyles = makeStyles((theme: Theme) => ({
    root: {
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: theme.shape.borderRadius,
        flex: 1,
        height: '100%',
        minHeight: 0,
        overflow: 'auto',
    },
    serviceDetailHeader: {
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        height: HEADER_H,
        boxSizing: 'border-box',
        padding: theme.spacing(1),
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 4,
        backgroundColor: theme.palette.background.paper,
    },
    serviceDetailHeaderContent: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    serviceDetailHeaderTitle: {
        ...(typographyStyle(theme.typography.body1) as Record<string, unknown>),
        fontWeight: 500,
        color: theme.palette.text.secondary,
    },
    serviceDetailHeaderValue: {
        ...(typographyStyle(theme.typography.body1) as Record<string, unknown>),
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    // Service Detail Row styles
    serviceDetailRowContainer: {
        boxSizing: 'border-box',
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        alignContent: 'flex-start',
    },
    serviceDetailRowContainerWithBorder: {
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
    serviceDetailRowHeader: {
        display: 'flex',
        boxSizing: 'border-box',
        alignItems: 'center',
        padding: theme.spacing(1),
        height: VENDOR_BAR_H,
    },
    assignUnitsButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minWidth: 0,
    },
    assignUnitsButton: {
        textTransform: 'none',
        fontWeight: 500,
        minHeight: 34,
        minWidth: 0,
        borderRadius: theme.shape.borderRadius,
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
        lineHeight: 1.1,
        '& .MuiButton-startIcon': {
            marginRight: theme.spacing(0.5),
            marginLeft: 0,
            alignSelf: 'center',
        },
        '&:focus-visible': {
            boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
        },
    },
    // Vendor Row styles
    vendorRowContainer: {
        height: VENDOR_BAR_H,
    },
    vendorRowCard: {
        width: '100%',
        borderRadius: theme.spacing(1),
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: `1px solid ${theme.palette.grey[200]}`,
        height: VENDOR_BAR_H,
    },
    vendorRowCardContent: {
        padding: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        height: '100%',
    },
    // Order control: disabled service row (not first service)
    orderControlDisabledRow: {
        boxSizing: 'border-box',
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.action.hover,
        opacity: 0.85,
        padding: theme.spacing(0, 1),
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'flex-start',
        overflow: 'hidden',
    },
    orderControlDisabledChartRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1, 2),
        backgroundColor: theme.palette.action.hover,
        opacity: 0.85,
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        color: theme.palette.text.secondary,
        textAlign: 'center',
        boxSizing: 'border-box',
    },
}))
